<template>
  <div class="relative header" :style="`height: ${height}`">
    <div v-if="overlay" class="gradient-overlay" :style="`height: ${height}`" />

    <video
      v-if="
        getContent(media_id, media_desc) &&
        getContent(media_id, media_desc).image_path.includes('webm')
      "
      :title="getContent(media_id, media_desc)?.image_desc"
      class="header-media"
      :style="`height: ${height}`"
      width="1920"
      height="1080"
      preload="metadata"
      autoplay
      muted
      loop
      playsinline
    >
      <source
        :src="getContent(media_id, media_desc).image_path"
        type="video/webm"
      />
    </video>

    <div
      v-if="
        getContent(media_id, media_desc) &&
        !getContent(media_id, media_desc).image_path.includes('webm')
      "
    >
      <NuxtImg
        :src="getContent(media_id, media_desc)?.image_path"
        :alt="getContent(media_id, media_desc)?.image_desc"
        class="header-media"
        :style="`height: ${height}`"
        loading="lazy"
        decoding="async"
        format="webp"
        quality="80"
      />
    </div>

    <div class="absolute w-100 h-100" style="top: 0">
      <v-container class="h-100">
        <slot />
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useMediaStore } from "@/stores/MediaStore";

export default {
  name: "Hero",
  props: {
    media_id: {
      type: Number,
      required: true,
    },
    media_desc: {
      type: String,
      required: false,
      default: "hero",
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      required: false,
      default: "90vh",
    },
  },
  methods: {
    ...mapActions(useMediaStore, ["getContent"]),
  },
};
</script>

<style scoped>
.header-media {
  display: block;
  width: 100vw;
  object-fit: cover;
  object-position: center;
}
.header {
  width: 100vw;
}
.gradient-overlay {
  position: absolute;
  width: 100vw;
  background: linear-gradient(
    359deg,
    rgba(0, 0, 0, 0.3) 0.72%,
    rgba(0, 0, 0, 0) 99.45%
  );
}
</style>
